// src/components/Navigation/RouteConfig.jsx
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { ROUTES, PUBLIC_ROUTES } from './routes';
import ProtectedRoute from './ProtectedRoute';
import PublicRoute from './PublicRoute';

// Page imports
import Home from '../../pages/Home';
import About from '../../pages/About';
import Services from '../../pages/services';
import Login from '../../pages/Login';
import Register from '../../pages/Register';
import GameLibrary from '../../pages/GameLibrary';
import StreamingSession from '../../pages/StreamingSession';
import Subscription from '../../pages/Subscription';
import Profile from '../../pages/Profile';
import Game2048 from '../../pages/GameFiles/A/puzzle';
import MemoryMatch from '../../pages/GameFiles/A/Memory';
import XOGame from '../../pages/GameFiles/A/Tictac';
import SudokuGame from '../../pages/GameFiles/A/Sudoku';
import SuccessPage from '../../pages/SuccessPage';
import LandingPage from '../../pages/LandingPage';
import ChessGame from '../../pages/GameFiles/A/chess';

const RouteConfig = () => {
  return (
    <Routes>
      {/* Public Routes */}
      <Route
        path={ROUTES.HOME}
        element={
          <PublicRoute>
          <Home />
          </PublicRoute>
        
        }
      />
            <Route
        path={ROUTES.About}
        element={
          <PublicRoute>
          <About />
          </PublicRoute>
        
        }
      />

      <Route
        path={ROUTES.Services}
        element={
          <PublicRoute>
          <Services />
          </PublicRoute>
        
        }
      />

      <Route
      path={ROUTES.LandingPage}
      element={<LandingPage />}
      />

      <Route
        path={ROUTES.LOGIN}
        element={
          <PublicRoute>
            <Login />
          </PublicRoute>
        }
      />
      <Route
        path={ROUTES.REGISTER}
        element={
          <PublicRoute>
            <Register />
          </PublicRoute>
        }
      />

      {/* Free Games */}
      <Route
        path="/games/2048"  // Update path to match GameLibrary navigation
        element={<Game2048 />}
      />
 
 <Route 
      path="/games/XOgame" 
      element={<XOGame />} 
      />

      <Route 
      path="/games/MemoryMatch" 
      element={<MemoryMatch />} 
      />

<Route 
      path="/games/SudokuGame" 
      element={<SudokuGame />} 
      />
<Route 
      path="/games/chess" 
      element={<ChessGame />} 
      />

      {/* Protected Routes */}

      <Route
        path={ROUTES.GAME_LIBRARY}
        element={
          <ProtectedRoute>
            <GameLibrary />
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.STREAM}
        element={
          <ProtectedRoute>
            <StreamingSession />
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.SUBSCRIPTION}
        element={
          <ProtectedRoute>
            <Subscription />
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.PROFILE}
        element={
          <ProtectedRoute>
            <Profile />
          </ProtectedRoute>
        }
      />
      <Route 
      path={ROUTES.SUCCESS} 
      element={
        <ProtectedRoute>
          <SuccessPage />
        </ProtectedRoute>} 
      />
      <Route path={ROUTES.CANCEL} 
      element={
        <ProtectedRoute>
          <SuccessPage />
        </ProtectedRoute>} 
      />
    </Routes>
  );
};

export default RouteConfig;